import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import fixbidsLogo from "@/assets/fixbids-logo.png";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary/5 via-muted/50 to-secondary/5 backdrop-blur-sm border-t border-border mt-20 relative z-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white p-2 rounded-lg">
                <img src={fixbidsLogo} alt="FixBids Logo" className="w-7 h-7 object-contain" width={28} height={28} loading="lazy" />
              </div>
              <span className="text-xl font-bold text-foreground">FixBids</span>
            </div>
            <p className="text-foreground/70 text-sm font-medium">
              FixBids – Η πλατφόρμα που συνδέει πελάτες με τεχνικούς
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Εταιρεία</h3>
            <ul className="space-y-2 text-sm text-foreground/70 font-medium">
              <li><Link to="/about" className="hover:text-primary transition-colors">Σχετικά με εμάς</Link></li>
              <li><Link to="/how-it-works" className="hover:text-primary transition-colors">Πώς λειτουργεί</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Επικοινωνία</Link></li>
              <li><Link to="/feedback" className="hover:text-primary transition-colors">Γνώμη σας</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Νομικά</h3>
            <ul className="space-y-2 text-sm text-foreground/70 font-medium">
              <li><Link to="/privacy-policy" className="hover:text-primary transition-colors">Πολιτική Απορρήτου</Link></li>
              <li><Link to="/terms" className="hover:text-primary transition-colors">Όροι Χρήσης</Link></li>
              <li><Link to="/cookie-policy" className="hover:text-primary transition-colors">Πολιτική Cookies</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Επικοινωνία</h3>
            <ul className="space-y-3 text-sm text-foreground/70 font-medium">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>info@fixbids.gr</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>Αθήνα, Ελλάδα</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-border text-center text-sm text-foreground/60 font-medium">
          <p>&copy; 2024 FixBids. Όλα τα δικαιώματα διατηρούνται.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
